import { PageViewTracker, useTrackEvent } from "@sg-protect/shell";
import { useEffect } from "react";
import { initDomEventTracker, removeDomEventTracker } from "./dom-event-tracker/index.ts";

export function AutomaticTelemetryInitializer() {
    const track = useTrackEvent();

    useEffect(() => {
        initDomEventTracker(track);

        return () => {
            removeDomEventTracker();
        };
    }, [track]);

    return <PageViewTracker />;
}
